import { Component, OnInit } from '@angular/core'
import { FormControl, Validators, FormGroup } from '@angular/forms'
import { Transaction } from '../imports/server.models'
import { TransactionService } from '../services/transaction.service'
import { errorObject } from '../imports/app.models'
import { Router } from '@angular/router'
import { AuthService } from '../services/auth.service'
import * as XLSX from 'xlsx'

@Component({
  selector: 'app-view-transactions',
  templateUrl: './view-transactions.component.html',
  styleUrls: ['./view-transactions.component.css']
})
export class ViewTransactionsComponent implements OnInit {

  transactions: Array<Transaction> = []
  editTransaction: Transaction = null
  notifications: Array<errorObject> = []
  months = [{ prop: 'Jan', name: 'Януари' },
  { prop: 'Feb', name: 'Февруари' },
  { prop: 'Mar', name: 'Март' },
  { prop: 'Apr', name: 'Април' },
  { prop: 'May', name: 'Май' },
  { prop: 'Jun', name: 'Юни' },
  { prop: 'Jul', name: 'Юли' },
  { prop: 'Aug', name: 'Август' },
  { prop: 'Sep', name: 'Септември' },
  { prop: 'Oct', name: 'Октомври' },
  { prop: 'Nov', name: 'Ноември' },
  { prop: 'Dec', name: 'Декември' }];

  searchQuery = ''
  originalTransactions: Transaction[]
  noResults: boolean = false
  selectedMonth: string
  Name: FormControl
  Amount: FormControl
  Type: FormControl
  Date: FormControl
  editForm: FormGroup

  constructor(private transactionService: TransactionService, private authService: AuthService, private router: Router) { }

  ngOnInit(): void {
    // get the current month
    const currentDate = new Date()
    const currentMonth = currentDate.toLocaleString('default', { month: 'short' })

    // find the matching month in the months array
    const monthObj = this.months.find(m => m.prop === currentMonth)

    // set the selectedMonth to the matching month's name
    this.selectedMonth = monthObj.prop

    this.getTransactionData();
    this.originalTransactions = this.transactions

  }

  get getSessionExpired() {
    if (!this.authService.isLoggedIn()) {
      return this.router.navigate(['/login'])
    }
  }

  filterTransactions() {
    this.transactions = this.originalTransactions.filter(transaction =>
      (this.selectedMonth === 'all' || transaction.getFormattedDate().includes(this.selectedMonth))
      && (this.searchQuery === '' || transaction.Name.toLowerCase().includes(this.searchQuery.toLowerCase()))
    )

    this.noResults = (this.searchQuery !== '') && (this.transactions.length === 0)
  }

  clearSearch() {
    this.searchQuery = ''
    this.filterTransactions()
  }

  getTransactionData() {
    this.transactions = []

    this.transactionService.getTransactions().subscribe(
      data => {
        this.setTransactions(data)
      },
      err => {
        console.log("err: ", err)
      }
    )
  }

  setTransactions(data: any) {
    for (let i = 0; i < data.length; i++) {
      let date = new Date(data[i].date)
      let transaction = new Transaction(data[i].name, data[i].amount, date, data[i].id)
      transaction.Type = data[i].type
      transaction.TransactionId = data[i].transactionId

      this.transactions.push(transaction)
    }
    this.filterTransactions()
    console.log(this.transactions)
  }

  convertArrayToCSV(arr: any[]): string {
    const delimiter = ','
    const lineEnding = '\r\n'
    const keys = Object.keys(arr[0])
    const csvHeader = keys.join(delimiter) + lineEnding
    const csvRows = arr.map((row) =>
      keys.map((key) => row[key]).join(delimiter)
    )

    return csvHeader + csvRows.join(lineEnding)
  }

  convertCSVtoXLSX(csvContent, filename) {
    const workbook = XLSX.utils.book_new()
    const worksheet = XLSX.utils.aoa_to_sheet(csvContent.split('\n').map(row => row.split(',')))
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')
    const xlsxContent = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
    const blob = new Blob([xlsxContent], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
    const downloadLink = document.createElement('a')
    downloadLink.setAttribute('href', URL.createObjectURL(blob))
    downloadLink.setAttribute('download', `${filename}.xlsx`)
    downloadLink.style.display = 'none'
    document.body.appendChild(downloadLink)
    downloadLink.click()
    document.body.removeChild(downloadLink)
  }

  exportToCSV() {
    const csvContent = "\uFEFF" + this.convertArrayToCSV(this.transactions)
    const filename = "MYLEV_Transactions_" + this.selectedMonth // Example filename using today's date
    this.convertCSVtoXLSX(csvContent, filename)
  }

  showTransactionModal(transaction: Transaction) {
    this.editTransaction = transaction
    this.createTransactionForm()
  }

  createTransactionForm() {
    this.Name = new FormControl(this.editTransaction.Name, [Validators.required])
    this.Amount = new FormControl(this.editTransaction.Amount, [Validators.required])
    this.Type = new FormControl(this.editTransaction.Type, [Validators.required])
    this.Date = new FormControl(this.editTransaction.Date, [Validators.required])

    this.editForm = new FormGroup({
      name: this.Name,
      amount: this.Amount,
      type: this.Type,
      date: this.Date
    })
  }

  dateFilter() {
    let date: Date = new Date(this.editTransaction.Date)
    let month: string = String(date.getMonth() + 1).padStart(2, '0') // Add leading zero if month < 10
    let day: string = String(date.getDate()).padStart(2, '0') // Add leading zero if day < 10
    let year: string = String(date.getFullYear())

    return `${month}/${day}/${year}`
  }

  deleteTransaction() {
    if (confirm("Сигурни ли сте, че искате да изтриете тази трансакция? ")) {
      this.transactionService.deleteTransactions(this.editTransaction).subscribe(
        data => {
          let message = `${this.editTransaction.Name} бе изтрита успешно`
          this.notifications.push(new errorObject(this.notifications.length, true, message))

          // Remove the deleted transaction from the transactions array
          const index = this.transactions.findIndex(t => t.TransactionId === this.editTransaction.TransactionId)
          if (index !== -1) {
            this.transactions.splice(index, 1)
          }
        },
        err => {
          if (typeof (err.error) != typeof (String))
            err.error = "Възникна неочаквана грешка, моля, опитайте отново по-късно"

          this.notifications.push(new errorObject(this.notifications.length, false, err.error))
        }
      );
      this.originalTransactions.length = this.originalTransactions.length - 1
    }
  }

  removeNotification(id: number) {
    let newNotifications: Array<errorObject> = []

    for (let i = 0; i < this.notifications.length; i++) {
      if (id !== this.notifications[i].id)
        newNotifications.push(this.notifications[i])
    }
    this.notifications = newNotifications
  }

  updateTransaction() {
    console.log('Updating')

    let date = this.Date.value
    if (date == undefined || date == null) {
      if (this.editTransaction.Date == null || this.editTransaction.Date == undefined) {
        date = Date.now()
      }
      else {
        date = this.editTransaction.Date
      }
    }

    date = new Date(this.Date.value)

    let transaction = new Transaction(
      this.Name.value,
      this.Amount.value,
      date,
      this.editTransaction.Id
    )
    transaction.TransactionId = this.editTransaction.TransactionId
    transaction.Type = this.Type.value

    this.transactionService.updateTransaction(transaction).subscribe(
      data => {
        let message = `${this.editTransaction.Name} беше редактирана успешно`
        this.notifications.push(new errorObject(
          this.notifications.length,
          true,
          message
        ));

        // Find the updated transaction in the transactions array and replace it with the updated data
        const index = this.transactions.findIndex(t => t.TransactionId === transaction.TransactionId)
        if (index >= 0) {
          this.transactions.splice(index, 1, transaction)
        }
      },
      err => {
        if (typeof (err.error) != typeof (String))
          err.error = "Възникна неочаквана грешка, моля, опитайте отново по-късно"

        this.notifications.push(new errorObject(
          this.notifications.length,
          false,
          err.error
        ))
      }
    )
  }
}